import React, { useContext, memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import classNames from 'classnames';
import { get, isEqual } from 'lodash';
import { connect } from 'react-redux';
import ThemeContext from '../../../containers/ThemeContext';
import { getComponentVersionProps } from '../../../utils/helpers';
import './Button.scss';

const MaterialButton = memo(
  ({
    type,
    id,
    variant,
    content,
    onClick,
    disabled,
    color,
    size,
    startIcon,
    endIcon,
    classList,
    component,
    disableElevation,
    themeData,
  }) => {
    const { themeContext } = useContext(ThemeContext);

    const materialElementV2 = useMemo(() => {
      const materialElementsVersion = get(
        getComponentVersionProps(themeData, 'material-elements'),
        'version',
      );
      return isEqual(materialElementsVersion, 'cv2');
    }, [themeData]);

    return (
      <Button
        id={id}
        classes={{
          root: classNames('material-button', classList, {
            [themeContext]: themeContext,
            materialElementV2,
          }),
        }}
        variant={variant}
        onClick={onClick}
        disabled={disabled}
        color={color}
        size={size}
        startIcon={startIcon}
        endIcon={endIcon}
        component={component}
        disableElevation={disableElevation}
      >
        {content}
      </Button>
    );
  },
);

MaterialButton.propTypes = {
  variant: PropTypes.string,
  content: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  color: PropTypes.string,
  size: PropTypes.string,
  startIcon: PropTypes.string,
  endIcon: PropTypes.string,
  type: PropTypes.string,
  disableElevation: PropTypes.bool,
};

MaterialButton.defaultProps = {
  variant: 'contained',
  content: '',
  disabled: false,
  color: 'primary',
  size: 'medium',
  startIcon: '',
  endIcon: '',
  type: 'button',
  disableElevation: true,
};

const mapStateToProps = (state) => ({
  themeData: get(state, 'common.resources.themeData', {}),
});

export default connect(mapStateToProps)(MaterialButton);
